import { atom } from 'jotai';
import {
  IAirTableFieldDataModel,
  IAirTableTableDataModel,
} from '../../../data-models/airtable-base.data-model';
import { IAirTableEntityDataModel } from '../../../data-models/airtable-entity.data-model';

export const configurationStepsState = atom<number>(0);

export const selectedTableState = atom<IAirTableTableDataModel | null>(null);

export const selectedEntityState = atom<IAirTableEntityDataModel | null>(null);

// map foresight index column(s) to airtable index col(s)
export const indexColumnMatchesState = atom<Map<string, IAirTableFieldDataModel>>(new Map());
